import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { ScrollArea } from "@/components/ui/scroll-area";

const Badge = ({ children, tone }) => (
  <span
    className={`text-[10px] font-mono px-2 py-0.5 rounded border ${tone}`}
  >
    {children}
  </span>
);

const diffTone = {
  初级: "border-emerald-500/40 text-emerald-500",
  中级: "border-amber-500/40 text-amber-500",
  高级: "border-rose-500/40 text-rose-500",
};

export const Tutorial = ({ course, loading }) => {
  if (loading || !course) {
    return (
      <div className="h-full flex items-center justify-center text-xs font-mono text-muted-foreground">
        加载教程中…
      </div>
    );
  }

  return (
    <div className="h-full flex flex-col bg-background min-w-0">
      <div className="px-5 py-3 border-b border-border shrink-0">
        <div className="flex items-center gap-2 mb-1.5">
          <Badge tone="border-blue-500/40 text-blue-500">{course.category}</Badge>
          <Badge tone={diffTone[course.difficulty] || "border-border text-muted-foreground"}>
            {course.difficulty}
          </Badge>
        </div>
        <h1 className="font-heading text-xl font-bold tracking-tight">{course.title}</h1>
        <p className="text-xs text-muted-foreground mt-1">{course.description}</p>
      </div>
      <ScrollArea className="flex-1">
        <article className="prose-doc px-5 py-4 fade-up" data-testid="tutorial-content">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{course.markdown}</ReactMarkdown>
        </article>
      </ScrollArea>
    </div>
  );
};
